export default function() {
	return {
		campaigns: [],
		campaign: {},
		defaultCampaign: {},
		campaignStatsData: {},
		impressionSum: 0,
		impressionChart: [],
		clickSum: 0,
		clickChart: [],
		reachSum: 0,
		reachChart: [],
	};
}
